import { Typography } from '@mui/material';

export function SectionHeader({ name }) {
  return (
    <>
      <Typography
        component="h5"
        sx={{
          fontSize: '1.4em',
          paddingTop: '8px',
        }}
      >
        {name}
      </Typography>
    </>
  );
}
